"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColorsForVariant = getColorsForVariant;
exports.getStylesForVariant = exports.defaultSize = exports.defaultVariant = void 0;

var _styledComponents = require("styled-components");

var _Theme = require("../../Theme");

/** Default button color variant */
var defaultVariant = "primaryBlack";
/** The size of the button */

exports.defaultVariant = defaultVariant;

/** Default button size */
var defaultSize = "medium";
exports.defaultSize = defaultSize;

/**
 * Returns various colors for each state given a button variant
 * @param variant
 */
function getColorsForVariant(variant) {
  var _themeProps$colors = _Theme.themeProps.colors,
      black100 = _themeProps$colors.black100,
      black10 = _themeProps$colors.black10,
      black30 = _themeProps$colors.black30,
      white100 = _themeProps$colors.white100,
      purple100 = _themeProps$colors.purple100;

  switch (variant) {
    case "primaryBlack":
      return {
        default: {
          backgroundColor: black100,
          borderColor: black100,
          color: white100
        },
        hover: {
          backgroundColor: purple100,
          borderColor: purple100,
          color: white100
        }
      };

    case "primaryWhite":
      return {
        default: {
          backgroundColor: white100,
          borderColor: white100,
          color: black100
        },
        hover: {
          backgroundColor: purple100,
          borderColor: purple100,
          color: white100
        }
      };

    case "secondaryGray":
      return {
        default: {
          backgroundColor: black10,
          borderColor: black10,
          color: black100
        },
        hover: {
          backgroundColor: black30,
          borderColor: black30,
          color: black100
        }
      };

    case "secondaryOutline":
      return {
        default: {
          backgroundColor: white100,
          borderColor: black10,
          color: black100
        },
        hover: {
          backgroundColor: white100,
          borderColor: black100,
          color: black100
        }
      };

    case "noOutline":
      return {
        default: {
          backgroundColor: "rgba(0, 0, 0, 0)",
          borderColor: "rgba(0, 0, 0, 0)",
          color: black100
        },
        hover: {
          backgroundColor: white100,
          borderColor: black100,
          color: black100
        }
      };

    default:
  }
}
/**
 * Returns css related to the passed in variant
 * @param variant
 */


var getStylesForVariant = function getStylesForVariant(variant) {
  var _getColorsForVariant = getColorsForVariant(variant),
      enabled = _getColorsForVariant.default,
      hover = _getColorsForVariant.hover;

  return (0, _styledComponents.css)(["", ";"], function () {
    return "\n          background-color: ".concat(enabled.backgroundColor, ";\n          border-color: ").concat(enabled.borderColor, ";\n          color: ").concat(enabled.color, ";\n\n          @media ").concat(_Theme.themeProps.mediaQueries.hover, " {\n            &:hover {\n              background-color: ").concat(hover.backgroundColor, ";\n              border-color: ").concat(hover.borderColor, ";\n              color: ").concat(hover.color, ";\n            }\n          }\n        ");
  });
};

exports.getStylesForVariant = getStylesForVariant;
//# sourceMappingURL=Button.shared.js.map